import type featuresEn from "./features.en";

const featuresAr: Record<keyof typeof featuresEn, string> = {
  "feat.title": "الميزات",
  "feat.description": "ميزات مدمجة كان متجرك سيحتاج تطبيقات لها. {on} من {total} مفعّلة. فعّل الميزة واضبط خياراتها ثم نسّق شكلها في محرر السمة.",
  "feat.read_only": "يمكنك رؤية الميزات المفعّلة. اطلب من مالك المتجر تغييرها.",
  "feat.search": "ابحث في الميزات",
  "feat.category.shopping": "التسوق",
  "feat.category.shopping_hint": "ساعد العملاء على إيجاد المنتجات واختيارها.",
  "feat.category.conversion": "زيادة المبيعات",
  "feat.category.conversion_hint": "حوّل المزيد من الزيارات إلى طلبات.",
  "feat.category.orders": "الطلبات",
  "feat.category.orders_hint": "بعد الشراء: التأكيد والتتبع والإرجاع.",
  "feat.category.engagement": "التفاعل",
  "feat.category.engagement_hint": "اجعل العملاء يعودون.",
  "feat.locked": "أوقفتها سوقنا",
  "feat.upgrade": "رقِّ الباقة",
  "feat.needs_other": "تحتاج ميزة أخرى",
  "feat.options": "الخيارات",
  "feat.customise": "تخصيص",
  "feat.manage": "إدارة",
  "feat.see_plans": "عرض الباقات",
  "feat.turned_on": "تم تفعيل {name}.",
  "feat.turned_off": "تم إيقاف {name}.",
  "feat.options_title": "خيارات {name}",
  "feat.options_note": "الألوان والنصوص والمواضع تُضبط في محرر السمة.",
  "feat.open_features": "فتح الميزات",
  "feat.off_banner": "{name} متوقفة. لن يراها العملاء حتى تفعّلها.",

  "feat.wishlist.name": "قائمة الأمنيات",
  "feat.wishlist.description": "يحفظ العملاء المنتجات لوقت لاحق بزر القلب في صفحات وبطاقات المنتجات. تُحفظ في حسابهم، أو في المتصفح للزوار.",
  "feat.wishlist.guest_wishlist": "يمكن للزوار حفظ المنتجات",
  "feat.wishlist.guest_wishlist_hint": "تُحفظ في متصفحهم وتنتقل إلى حسابهم عند تسجيل الدخول.",
  "feat.wishlist.max_items": "أقصى عدد منتجات في القائمة",
  "feat.wishlist.max_items_hint": "بين 10 و500.",
  "feat.product_search.name": "البحث والفلاتر",
  "feat.product_search.description": "اقتراحات فورية أثناء الكتابة، وفلاتر حسب السعر والتوفر والخيارات وغيرها.",
  "feat.variants_display.name": "عينات الخيارات",
  "feat.variants_display.description": "عينات ألوان وصور للخيارات، مع سعر ومخزون وصورة الخيار المختار.",
  "feat.reviews.name": "تقييمات المنتجات",
  "feat.reviews.description": "نجوم وتقييمات على المنتجات مع شارة المشتري الموثّق. توافق على التقييمات قبل ظهورها.",
  "feat.reviews.auto_publish": "النشر دون موافقة",
  "feat.reviews.auto_publish_hint": "التقييمات التي لا تُنشر تلقائياً تنتظرك في صفحة التقييمات.",
  "feat.reviews.auto_publish.off": "أبداً: أوافق على كل تقييم",
  "feat.reviews.auto_publish.four_plus": "تقييمات 4 و5 نجوم",
  "feat.reviews.auto_publish.all": "كل التقييمات",
  "feat.reviews.verified_only": "التقييم للمشترين فقط",
  "feat.reviews.verified_only_hint": "يحتاج التقييم بريد طلب يتضمن المنتج.",
  "feat.reviews.request_email": "اطلب تقييماً من المشترين",
  "feat.reviews.request_email_hint": "رسالة للعملاء بعد توصيل طلبهم.",
  "feat.reviews.request_delay_days": "أيام بعد التوصيل",
  "feat.reviews.request_delay_days_hint": "متى يُرسل طلب التقييم.",
  "feat.related_products.name": "منتجات مشابهة وشوهدت مؤخراً",
  "feat.related_products.description": "\"قد يعجبك أيضاً\" في صفحات المنتجات، والمنتجات التي شاهدها العميل مؤخراً.",
  "feat.related_products.recently_viewed": "إظهار ما شوهد مؤخراً",
  "feat.related_products.recently_viewed_hint": "يُحفظ في متصفح العميل.",
  "feat.back_in_stock.name": "تنبيهات توفر المنتج",
  "feat.back_in_stock.description": "يطلب العملاء إشعارهم عند توفر منتج نفد، ويصلهم التنبيه فور توفره.",
  "feat.back_in_stock.whatsapp": "تنبيهات واتساب",
  "feat.back_in_stock.whatsapp_hint": "عند ربط رقم واتساب في الإشعارات.",
  "feat.back_in_stock.min_quantity": "التنبيه عند بلوغ المخزون",
  "feat.back_in_stock.min_quantity_hint": "عدد الوحدات المتوفرة قبل إرسال التنبيهات.",
  "feat.abandoned_cart.name": "استرجاع السلال المتروكة",
  "feat.abandoned_cart.description": "تذكير العملاء الذين تركوا الدفع برابط يعيدهم إلى سلتهم وخصم اختياري.",
  "feat.abandoned_cart.audience": "من يستلم التذكير",
  "feat.abandoned_cart.audience_hint": "تذكير من لم يوافق على التسويق قد لا يُسمح به في كل مكان.",
  "feat.abandoned_cart.audience.all": "كل من ترك بريداً أو هاتفاً",
  "feat.abandoned_cart.audience.subscribed": "المشتركون في التسويق فقط",
  "feat.abandoned_cart.step1_hours": "التذكير الأول بعد (ساعات)",
  "feat.abandoned_cart.step1_hours_hint": "ساعات بعد ترك العميل لصفحة الدفع.",
  "feat.abandoned_cart.step2_hours": "التذكير الثاني بعد (ساعات)",
  "feat.abandoned_cart.step2_hours_hint": "0 يعني دون تذكير ثانٍ.",
  "feat.abandoned_cart.step3_hours": "التذكير الثالث بعد (ساعات)",
  "feat.abandoned_cart.step3_hours_hint": "0 يعني دون تذكير ثالث.",
  "feat.abandoned_cart.discount_percent": "خصم في التذكير (%)",
  "feat.abandoned_cart.discount_percent_hint": "رمز لمرة واحدة ينتهي بعد 48 ساعة. 0 يعني دون خصم.",
  "feat.abandoned_cart.discount_step": "التذكير الذي يحمل الخصم",
  "feat.abandoned_cart.discount_step_hint": "1 أو 2 أو 3.",
  "feat.abandoned_cart.whatsapp": "التذكير عبر واتساب أيضاً",
  "feat.abandoned_cart.whatsapp_hint": "عند ربط رقم واتساب وإدخال العميل رقم هاتف.",
  "feat.discounts_storefront.name": "الخصومات في المتجر",
  "feat.discounts_storefront.description": "حقل رمز الخصم في السلة، والخصومات التلقائية وشريط التقدم نحو الشحن المجاني.",
  "feat.discounts_storefront.free_shipping_threshold": "الشحن مجاني من",
  "feat.discounts_storefront.free_shipping_threshold_hint": "يظهر في شريط التقدم. اتركه 0 لاستخدام سعر الشحن المجاني لديك.",
  "feat.cod_confirmation.name": "تأكيد الدفع عند الاستلام",
  "feat.cod_confirmation.description": "يؤكد العملاء طلبات الدفع عند الاستلام عبر البريد أو واتساب قبل الشحن، فتقل الطلبات المرفوضة عند الباب.",
  "feat.cod_confirmation.hold_fulfillment": "الإيقاف حتى التأكيد",
  "feat.cod_confirmation.hold_fulfillment_hint": "لا يمكن تجهيز الطلبات غير المؤكدة حتى يؤكدها العميل أو تؤكدها أنت.",
  "feat.cod_confirmation.whatsapp": "السؤال عبر واتساب",
  "feat.cod_confirmation.whatsapp_hint": "عند ربط رقم واتساب وإدخال العميل رقم هاتف.",
  "feat.cod_confirmation.reminder_hours": "التذكير بعد (ساعات)",
  "feat.cod_confirmation.reminder_hours_hint": "0 يعني دون تذكير.",
  "feat.cod_confirmation.auto_cancel_hours": "إلغاء الطلبات غير المؤكدة بعد (ساعات)",
  "feat.cod_confirmation.auto_cancel_hours_hint": "0 يعني عدم الإلغاء التلقائي.",
  "feat.whatsapp_share.name": "المشاركة والمحادثة عبر واتساب",
  "feat.whatsapp_share.description": "أزرار مشاركة على المنتجات وزر محادثة واتساب يفتح محادثة مع متجرك.",
  "feat.order_notifications.name": "تحديثات الطلب عبر واتساب",
  "feat.order_notifications.description": "تأكيد الطلب وتحديثات الشحن والتوصيل عبر واتساب إضافة إلى البريد.",
  "feat.product_badges.name": "شارات المنتجات",
  "feat.product_badges.description": "شارات جديد وتخفيض والأكثر مبيعاً ومخزون قليل ونفد على بطاقات وصفحات المنتجات.",
  "feat.product_badges.bestseller_count": "الأكثر مبيعاً",
  "feat.product_badges.bestseller_count_hint": "عدد المنتجات الأعلى مبيعاً التي تحمل الشارة.",
  "feat.product_badges.bestseller_days": "الأكثر مبيعاً خلال (أيام)",
  "feat.product_badges.bestseller_days_hint": "تُحسب المبيعات خلال هذه الأيام.",
  "feat.announcement_bar.name": "شريط الإعلانات",
  "feat.announcement_bar.description": "رسائل فوق الترويسة مع تاريخ بدء وانتهاء ودول وزر إغلاق.",
  "feat.newsletter_capture.name": "الاشتراك في النشرة",
  "feat.newsletter_capture.description": "نماذج اشتراك ونافذة منبثقة اختيارية. ينضم المشتركون إلى عملائك بموافقة تسويقية.",
  "feat.stock_status.name": "حالة المخزون",
  "feat.stock_status.description": "متوفر ومخزون قليل ونفد في صفحات وبطاقات المنتجات.",
  "feat.size_guide.name": "دليل المقاسات",
  "feat.size_guide.description": "رابط دليل المقاسات في صفحة المنتج يفتح جدول المقاسات حسب نوع المنتج أو لكل منتج.",
  "feat.order_tracking.name": "تتبع الطلب",
  "feat.order_tracking.description": "يبحث العملاء عن طلبهم برقمه والبريد أو الهاتف، ويرون حالته وتتبعه.",
  "feat.returns_requests.name": "طلبات الإرجاع",
  "feat.returns_requests.description": "يطلب العملاء الإرجاع أو الاستبدال من حسابهم، وتوافق عليها من الطلبات.",
  "feat.returns_requests.window_days": "مدة الإرجاع (أيام)",
  "feat.returns_requests.window_days_hint": "الأيام بعد التوصيل التي يمكن فيها طلب الإرجاع.",
  "feat.returns_requests.reasons": "أسباب الإرجاع",
  "feat.returns_requests.reasons_hint": "يختار العميل سبباً. اضغط Enter بعد كل سبب.",
  "feat.returns_requests.exchanges": "السماح بالاستبدال",
  "feat.returns_requests.exchanges_hint": "يمكن للعملاء طلب مقاس أو لون آخر بدل الاسترداد.",
  "feat.reorder.name": "اشترِ مجدداً",
  "feat.reorder.description": "زر \"اشترِ مجدداً\" في الطلبات السابقة يعيد المنتجات نفسها إلى السلة.",
  "feat.gift_cards.name": "بطاقات الهدايا",
  "feat.gift_cards.description": "بِع بطاقات الهدايا وأرسلها للمستلم بالبريد واقبلها كوسيلة دفع عند الشراء.",
  "feat.gift_cards.expiry_months": "تنتهي البطاقة بعد (أشهر)",
  "feat.gift_cards.expiry_months_hint": "0 يعني أنها لا تنتهي. تحقق من الأنظمة حيث تبيع.",
  "feat.gift_message.name": "رسائل الهدايا",
  "feat.gift_message.description": "يحدد العملاء الطلب كهدية ويضيفون رسالة عند الدفع.",
  "feat.gift_message.max_length": "أطول رسالة (حرف)",
  "feat.gift_message.max_length_hint": "بين 20 و1000.",
  "feat.quick_view.name": "العرض السريع",
  "feat.quick_view.description": "فتح المنتج من المجموعة في نافذة منبثقة وإضافته للسلة دون مغادرة الصفحة.",
  "feat.image_zoom.name": "تكبير الصور",
  "feat.image_zoom.description": "تكبير صور المنتج في صفحة المنتج.",
};

export default featuresAr;
